const dev = {
  BUILD_ENV: 'local',
  DOMAIN: 'localhost',
  API_BASE_URL: 'http://localhost:2000',
  LOGIN_URL: 'http://localhost:4001',
  ADMIN_URL: 'http://localhost:4001',
  STORE_URL: 'http://localhost:4002',
  SUPPLIER_URL: 'http://localhost:4003',
  VERSION: '0.4.2',
};

const internal = {
  BUILD_ENV: 'internal',
  DOMAIN: 'internal',
  API_BASE_URL: 'http://192.168.100.41:2000/',
  LOGIN_URL: 'http://localhost:4000',
  ADMIN_URL: 'http://localhost:4001',
  STORE_URL: 'http://localhost:4002',
  SUPPLIER_URL: 'http://localhost:4003',
  VERSION: '0.0.2',
};

const stage = {
  BUILD_ENV: 'stage',
  DOMAIN: 'stage',
  API_BASE_URL: 'https://backend-dev.bakeasy.online', // UAT
  VERSION: '0.4.5',
};

const prod = {
  BUILD_ENV: 'prod',
  DOMAIN: 'prod',
  API_BASE_URL: 'https://backend.order-ez.com',
  VERSION: '0.0.4',
};
export default stage;
